import { useAuth } from '../contexts/AuthContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export function CompanyFilter({ companies, value, onChange, className = "w-48" }) {
  const { user } = useAuth();

  // Non-super-admin: backend already scopes data, hide the company dropdown
  if (user?.role !== 'super_admin') {
    const myCompany = companies.find(c => c.company_id === user?.company_id);
    if (myCompany) {
      return (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-100 rounded-md">
          <span className="text-xs text-slate-500">Company:</span>
          <span className="text-xs font-semibold text-slate-700" data-testid="scoped-company-name">{myCompany.name}</span>
        </div>
      );
    }
    return null;
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`${className} bg-white`} data-testid="filter-company">
        <SelectValue placeholder="All Companies" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Companies</SelectItem>
        {companies.map(c => (
          <SelectItem key={c.company_id} value={c.company_id}>{c.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
